<template>
  <SvgIcon class="w12 h12" icon="16-Filled-Cloture" />
</template>
